import { ElementAttribute } from "../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../library-js/dom-tools/ElementType";
import * as QRCode from "qrcode";
import { OnChange, OnClick, OnInput } from "../../library-js/dom-tools/EventListeners";
import { HTMLEditor } from "../../library-js/dom-tools/HTMLEditor";
import { SimpleDownload } from "../../library-js/dom-tools/SimpleDownload";
export class QRCodeGenerator
{
  static readonly type  = new ElementType( "qr--code" );
  static readonly value = new ElementAttribute( "qr--value" );
  static readonly urlOnClick = new ElementAttribute( "qr--url--on--click" );
  static readonly urlOnLoad = new ElementAttribute( "qr--url--on--load" );
  static readonly fromInput = new ElementAttribute( "qr--from--input" );
  static readonly downlodaButton = new ElementAttribute( "qr--download--button" );

  static applyOnDocument()
  {
    QRCodeGenerator.type.forAllInDoc( e => QRCodeGenerator.applyOnElement( e ) );
  }

  static applyOnElement( element:Element )
  {
    if ( QRCodeGenerator.value.in( element ) )
    {
      QRCodeGenerator.generate( element, QRCodeGenerator.value.from( element ) );
      return;
    }    
    
    if ( QRCodeGenerator.urlOnClick.in( element ) )
    {
      let creator = ()=>
      {
        let url = window.location.href;
        QRCodeGenerator.generateURL( element, url );
        OnClick.remove( element as HTMLElement, creator );
      };

      OnClick.add( element as HTMLElement, creator  );
    }

    if ( QRCodeGenerator.urlOnLoad.in( element ) )
    {      
      let url = window.location.href;
      QRCodeGenerator.generateURL( element, url );
    }

    if ( QRCodeGenerator.fromInput.in( element ) )
    {  
      let target = QRCodeGenerator.fromInput.queryValueInDoc( element ) as HTMLInputElement;

      OnInput.add( target, 
        async ()=>
        {
          let text = target.value;
          console.log( "Creating text:", text );
          await QRCodeGenerator.generate( element, text );
          console.log( "Created text:", text );
        }
      );

      let button = QRCodeGenerator.downlodaButton.queryValueInDoc( element ) as HTMLButtonElement;

      OnClick.add( button,
        ()=>
        {
          SimpleDownload.downloadCanvas( "qr-code.png", ElementType.canvas.query( element ) ); 
        }
      );

      let text = target.value;
      console.log( "Creating text:", text );
      QRCodeGenerator.generate( element, text );

    }
  }

  static async generateURL( element:Element, url:string, canvas:HTMLCanvasElement = null ):Promise<void>
  {
    await QRCodeGenerator.generate( element, url, canvas );

    HTMLEditor.wrapWithAnchorHref( element, url );

    return Promise.resolve();
  }


  static async generate( element:Element, text:string, canvas:HTMLCanvasElement = null ):Promise<void>
  {
    element.innerHTML = "";

    canvas = canvas || ElementType.canvas.create();
    canvas.width  = 1024;
    canvas.height = 1024;


    let promise =  new Promise<void>(
      ( resolve, reject )=>
      {
        QRCode.toCanvas( 
          canvas, text,  ( error )=>
          {
            if ( error )
            {
              reject();
            }
            else
            {
              resolve();
              
              //ElementAttribute.width.removeFrom( canvas );
              //ElementAttribute.height.removeFrom( canvas );
              ElementAttribute.style.removeFrom( canvas );
              
              element.appendChild( canvas );
            }
          }  
        );
      }
    );

    return promise;
  }
}